// extracted by mini-css-extract-plugin
module.exports = {"title":"AddAccessoryForm_title__2w1vm","description":"AddAccessoryForm_description__1Wyf7","notice":"AddAccessoryForm_notice__1zd65","actions":"AddAccessoryForm_actions__3g8KP"};